import { queryClient } from '@/queries/client';

// Local causality only: this sequence is never sent to a server. Weak keys follow
// cache lifetime; optimistic writes and rollbacks do not establish read freshness.
let sequence = 0;
const observations = new WeakMap<object, { stream: number; request: number }>();
const cachedQuery = (scope: string, id: string) =>
  queryClient.getQueryCache().find({ queryKey: [scope, 'statuses', id], exact: true });

const observeStreamStatus = (scope: string, id: string) => {
  const query = cachedQuery(scope, id);
  if (query) observations.set(query, { stream: ++sequence, request: 0 });
};

const beginStatusRead = (scope: string) => {
  const order = ++sequence;
  return {
    isStatusCurrent: (id: string) => {
      const query = cachedQuery(scope, id);
      const seen = query && observations.get(query);
      return !seen || (seen.stream <= order && seen.request <= order);
    },
    didImportStatus: (id: string) => {
      const query = cachedQuery(scope, id);
      if (!query) return;
      const seen = observations.get(query);
      observations.set(query, {
        stream: seen?.stream ?? 0,
        request: Math.max(order, seen?.request ?? 0),
      });
    },
  };
};

export { beginStatusRead, observeStreamStatus };
